import React from 'react';
import { Field } from 'redux-form';
import ReduxFormInput from 'shared/components/ReduxFormInput';
import ReduxFormSelect from 'shared/components/ReduxFormSelect';
import ReduxFormDatePicker from 'shared/components/ReduxFormDatePicker';
import { PropTypes } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { MANDATORY, SKIP } from 'redux/domain/Settings/constants';

class GridFormField extends React.Component {
	fieldValidation = (value, allValues, props, name) => {
		const { validation } = this.props;
		if (typeof validation === 'function') {
			return validation(value, allValues, props, name);
		} else if (Array.isArray(validation)) {
			return validation.reduce((acc, val) => acc || val(value, allValues, props, name), undefined);
		}
		return undefined;
	};

	render() {
		const {
			fieldSettings: { fieldStatus },
			gridItemSize,
			select,
			type,
			validation,
			...other
		} = this.props;
		return fieldStatus == null || fieldStatus === SKIP ? null : (
			<Grid item {...gridItemSize}>
				<Field
					// Note from redux-form docs: "If the validate prop changes the field will be re-registered."
					// i.e. do not use inline arrow functions or any function that is created/recreated during render
					validate={this.fieldValidation}
					component={select ? ReduxFormSelect : type && type === "date" ? ReduxFormDatePicker : ReduxFormInput}
					fullWidth
					required={fieldStatus === MANDATORY}
					{...other}
				/>
			</Grid>
		);
	}
}

GridFormField.propTypes = {
	fieldSettings: PropTypes.shape({
		fieldStatus: PropTypes.string,
	}),
	gridItemSize: PropTypes.shape({
		xs: PropTypes.number,
		sm: PropTypes.number,
		md: PropTypes.number,
		lg: PropTypes.number,
		xl: PropTypes.number,
	}),
	select: PropTypes.bool,
	validation: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
};

GridFormField.defaultProps = {
	fieldSettings: {},
	gridItemSize: {
		xs: 12,
		md: 6,
	},
	select: false,
	validation: () => undefined,
};

export default GridFormField;
